import React from 'react';
import { BooleanColumn, NumericalColumn, CustomColumn, CategoricalColumn, StringColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';
import { EMPTY_ARRAY, CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	code: 'code',
	description: 'description',
	validFrom: 'validFrom',
	validTill: 'validTill',
	isOpen: 'isOpen',
	isDisabled: 'isDisabled',
	isHiddenFromApp: 'isHiddenFromApp',
	isFirstDeposit: 'isFirstDeposit',
	isSecondDeposit: 'isSecondDeposit',
	allowedPaymentModes: 'allowedPaymentModes',
	allowedPlatforms: 'allowedPlatforms',
	segmentsInclusive: 'segmentsInclusive',
	segmentsExclusive: 'segmentsExclusive',
	type: 'type',
	bucket: 'bucket',
	maxRedemptionsPerPerson: 'maxRedemptionsPerPerson',
	numRedemptions: 'numRedemptions',
	maxRedemptions: 'maxRedemptions',
	redemptionInterval: 'redemptionInterval',
	sortOrder: 'sortOrder',
	createdOn: 'createdOn',
	uptoCashback: 'uptoCashback',
	cashbackExpiryInHours: 'cashbackExpiryInHours'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Code',
		mapDataToValue: (data: any) => data[COL_NAMES.code] || '',
		maxWidth: 250,
		minWidth: 200
	}),
	CustomDateColumn({
		title: 'Valid From',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.validFrom
	}),
	CustomDateColumn({
		title: 'Valid Till',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.validTill
	}),
	BooleanColumn({
		title: 'isOpen',
		mapDataToValue: (data: any) => data[COL_NAMES.isOpen],
		maxWidth: 200
	}),
	CustomColumn({
		title: 'Is Deployed',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: !value ? 'green' : 'red',
						height: '100%',
						width: '100%'
					})}
				/>
			);
		}
	}),
	BooleanColumn({
		title: 'Hidden from App',
		mapDataToValue: (data: any) => data[COL_NAMES.isHiddenFromApp],
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'isFirstDeposit',
		mapDataToValue: (data: any) => data[COL_NAMES.isFirstDeposit],
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'isSecondDeposit',
		mapDataToValue: (data: any) => data[COL_NAMES.isSecondDeposit],
		maxWidth: 200
	}),
	CustomColumn({
		title: 'allowedPaymentModes',
		mapDataToValue: (data: any) => (data[COL_NAMES.allowedPaymentModes] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	// CustomColumn({
	// 	title: 'allowedPlatforms',
	// 	mapDataToValue: (data: any) => (data[COL_NAMES.allowedPlatforms] || EMPTY_ARRAY).join(','),
	// 	renderCell: (params: any) => params.value
	// }),
	CustomColumn({
		title: 'segmentsInclusive',
		mapDataToValue: (data: any) => (data[COL_NAMES.segmentsInclusive] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	CustomColumn({
		title: 'segmentsExclusive',
		mapDataToValue: (data: any) => (data[COL_NAMES.segmentsExclusive] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	CategoricalColumn({
		title: 'type',
		mapDataToValue: (data: any) => data[COL_NAMES.type] || '',
		maxWidth: 450
	}),
	NumericalColumn({
		title: 'Max No. of Redemptions',
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptions] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'maxRedemptionsPerPerson',
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptionsPerPerson] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'No. of Redemptions',
		mapDataToValue: (data: any) => data[COL_NAMES.numRedemptions] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Redemption Interval',
		mapDataToValue: (data: any) => data[COL_NAMES.redemptionInterval] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Sort Order',
		mapDataToValue: (data: any) => data[COL_NAMES.sortOrder] || '',
		maxWidth: 450
	}),
	CustomDateColumn({
		title: 'Created On',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdOn
	}),
	NumericalColumn({
		title: 'Upto Cashback',
		mapDataToValue: (data: any) => data[COL_NAMES.uptoCashback] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Cashback Expiry',
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackExpiryInHours] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Description',
		mapDataToValue: (data: any) => data[COL_NAMES.description] || ''
	}),
	BooleanColumn({
		title: 'Is Disabled',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled]
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
